import { render, staticRenderFns } from "./WishListCard.vue?vue&type=template&id=3f854277&scoped=true"
import script from "./WishListCard.vue?vue&type=script&lang=js"
export * from "./WishListCard.vue?vue&type=script&lang=js"
import style0 from "./WishListCard.vue?vue&type=style&index=0&id=3f854277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f854277",
  null
  
)

export default component.exports